module.exports = __webpack_public_path__ + "static/media/calendar-check.96ce0aaa.svg";